module.exports = __webpack_public_path__ + "img/scissors-cut-01.87ad7cda.svg";